const firebaseConfig = {

    apiKey: "AIzaSyCz2oVIFQpYdtY2L_wFhujcGvzg_FAL6-4",
  
    authDomain: "fir-auth-de88c.firebaseapp.com",
  
    projectId: "fir-auth-de88c",
  
    storageBucket: "fir-auth-de88c.appspot.com",
  
    messagingSenderId: "1004519049713",
  
    appId: "1:1004519049713:web:e949262643922010835c50"
  
  };

  export default firebaseConfig;